const encoded = (value) => encodeURIComponent(value);

const createControlApi = (baseUrl) => ({
  buildInfo: `${baseUrl}/system/build-info`,
  catalog: `${baseUrl}/module-catalog`,
  catalogModules: `${baseUrl}/module-catalog/modules`,
  catalogModule: (moduleId) => `${baseUrl}/module-catalog/modules/${encoded(moduleId)}`,
  catalogModuleImages: (moduleId, order = 'newest') => `${baseUrl}/module-catalog/modules/${encoded(moduleId)}/images?order=${encoded(order)}`,
  catalogPresets: `${baseUrl}/module-catalog/presets`,
  catalogPreset: (presetId) => `${baseUrl}/module-catalog/presets/${encoded(presetId)}`,
  contracts: `${baseUrl}/module-catalog/contracts`,
  validateContract: `${baseUrl}/module-catalog/contracts/validate`,
  contractVersion: (id, version) => `${baseUrl}/module-catalog/contracts/${encoded(id)}/${encoded(version)}`,
  publishContract: (id, version) => `${baseUrl}/module-catalog/contracts/${encoded(id)}/${encoded(version)}/publish`,
  defaultModuleSettings: `${baseUrl}/module-settings/defaults`,
  node: (nodeId) => `${baseUrl}/demo-nodes/${encoded(nodeId)}`,
  nodeModuleSettings: (nodeId) => `${baseUrl}/demo-nodes/${encoded(nodeId)}/module-settings`,
  sessions: `${baseUrl}/demo-sessions`,
  session: (sessionId) => `${baseUrl}/demo-sessions/${encoded(sessionId)}`,
  users: `${baseUrl}/users`,
  adminUsers: `${baseUrl}/admin/users`,
  adminInvites: `${baseUrl}/admin/invites`,
  registrationPolicy: `${baseUrl}/admin/registration-policy`,
  adminUser: (username) => `${baseUrl}/admin/users/${encoded(username)}`
});

export default createControlApi;
